import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import DataTable from 'components/organisms/DataTable'
import SearchField from 'components/atoms/SearchField'
import SubmitButton from 'components/atoms/buttons/SubmitButton'
import PaginationControl from 'components/organisms/PaginationControl'

import { adminColumns } from './'

export const styles = theme => ({
  root: {},
  header: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  inviteButton: {
    marginLeft: theme.spacing(3),
  },
  table: {
    marginTop: theme.spacing(6),
  },
})

const AdministrationOverview = ({
  users,
  classes,
  filters,
  tableLoading,
  onPageChange,
  onSearchChange,
  onTableSortClick,
  onInviteAdminClick,
  onTableSelectableClick,
}) => (
  <div className={classes.root}>
    <div className={classes.header}>
      <Typography variant="h1">All admins</Typography>
      <div style={{ display: 'inherit' }}>
        <SearchField onChange={onSearchChange} />
        <SubmitButton
          autoFocus
          size="medium"
          type="submit"
          color="primary"
          variant="primary"
          onClick={onInviteAdminClick}
          className={classes.inviteButton}>
            Invite new admin
        </SubmitButton>
      </div>
    </div>
    <DataTable
      key="Admin table"
      dataProvider={users}
      columns={adminColumns}
      className={classes.table}
      tableLoading={tableLoading}
      emptyStateTitle="No results"
      onSortClick={onTableSortClick}
      onSelectableClick={onTableSelectableClick}
      emptyStateDescription="Please try clearing your filters and try again"
    />
    <PaginationControl
      pagination={filters.pagination}
      onPageChange={onPageChange}
    />
  </div>
)

AdministrationOverview.propTypes = {
  users: PropTypes.object,
  classes: PropTypes.object,
  filters: PropTypes.object,
  tableLoading: PropTypes.bool,
  onPageChange: PropTypes.func,
  onSearchChange: PropTypes.func,
  onTableSortClick: PropTypes.func,
  onInviteAdminClick: PropTypes.func,
  onTableSelectableClick: PropTypes.func,
}

export default withStyles(styles)(AdministrationOverview)



// WEBPACK FOOTER //
// ./src/containers/organisation/AdministrationOverview/AdministrationOverview.js